import React, { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
// Colors configuration
const colors = {
  dark_blue: "#0a192f",
  white: "#ffffff",
  button: "#007bff",
  danger: "#dc3545",
  success: "#28a745",
  overlay: "rgba(0, 0, 0, 0.7)"
};

const SinaniumMainPage = () => {
  // --- API CONFIGURATION ---
  const CONTACT_API_URL = "https://space-game-api-a44029c2669c.herokuapp.com/contact";
  const REPORT_ABUSE_API_URL = "https://space-game-api-a44029c2669c.herokuapp.com/report_issues";

  // --- STATE ---
  // Account Deletion State
  const [deleteId, setDeleteId] = useState("");

  // Contact Form State
  const [contactSubject, setContactSubject] = useState("");
  const [contactMessage, setContactMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Popup State
  const [showPopup, setShowPopup] = useState(false);

  // --- HANDLERS ---

  const onContactUsFormClicked = (event) => {
    // preent default form submission
    event.preventDefault();
    setIsSubmitting(true);
        // Prepare Data: Fill empty fields with "not entered value"
    const finalSubject = contactSubject.trim() === "" ? "not entered value" : contactSubject;
    const finalMessage = contactMessage.trim() === "" ? "not entered value" : contactMessage;
    // check if email is valid
    const apiUrl = process.env.REACT_APP_API_URL;
    fetch(`${apiUrl}/contact_us`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: finalSubject,
        first_name: "user with no first name",
        last_name: "user with no last name",
        description: finalMessage
      }),
    })
    .then(response => response.json())
    .then(data => {
      toast("We have received your message and will contact you within 72 hours. Thank you!",{
        position: "top-center",
        type: "success"
        });
    })
    .catch((error) => {
      console.error('Error:', error);
      toast("Something happened! Please try again!",{
        position: "top-center",
        type: "error"
        });
    });
    // // clear the form
    // setEmailAddress("")
    // setFirstName("")
    // setLastName("")
    // setDescription("")
    setIsSubmitting(false);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: colors.dark_blue,
        minHeight: "100vh",
        padding: "20px",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        position: "relative" // For popup positioning
      }}
    >
      <div
        style={{
          backgroundColor: colors.white,
          color: "#333",
          padding: "40px",
          borderRadius: "12px",
          width: "100%",
          maxWidth: "800px",
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.5)",
        }}
      >
        {/* --- HERO SECTION --- */}
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <ToastContainer />
          <h1 style={{ fontSize: "2.5rem", margin: "0 0 10px 0", color: colors.dark_blue }}>
            Sinanium: Galactic Dominion
          </h1>
          <p style={{ fontSize: "1.2rem", color: "#666" }}>
            Official Support & Data Management Center
          </p>
          <div style={{ width: "60px", height: "4px", backgroundColor: colors.button, margin: "20px auto" }}></div>
        </div>

        {/* --- GRID LAYOUT --- */}
        <div style={{ display: "flex", flexDirection: "column", gap: "40px" }}>

           {/* --- SECTION 2: CONTACT & REPORT ABUSE --- */}
          <div style={{ padding: "25px", border: "1px solid #e9ecef", borderRadius: "8px", backgroundColor: "#f8f9fa" }}>
            <h2 style={{ marginTop: 0, color: colors.dark_blue }}>✉ Contact Support & Report Abuse</h2>
            <p style={{ fontSize: "0.95rem", color: "#555" }}>
              Found a bug? Need to report bad behavior? Fill out the form below.
            </p>

            <form onSubmit={onContactUsFormClicked} style={{ marginTop: "20px", display: "flex", flexDirection: "column", gap: "15px" }}>
              <div>
                <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Subject / Reason:</label>
                <select
                  value={contactSubject}
                  onChange={(e) => setContactSubject(e.target.value)}
                  style={{ width: "100%", padding: "10px", borderRadius: "5px", border: "1px solid #ccc", fontSize: "16px" }}
                >
                  <option value="">-- Select a Topic --</option>
                  <option value="General Inquiry">General Inquiry / Feedback</option>
                  <option value="Bug Report">Bug Report</option>
                  <option value="Report Abuse">Report Abuse / Bad Behavior</option>
                  <option value="Billing Issue">Billing Issue</option>
                </select>
              </div>

              <div>
                <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Message:</label>
                <textarea
                  rows="5"
                  value={contactMessage}
                  onChange={(e) => setContactMessage(e.target.value)}
                  placeholder="Describe your issue here..."
                  style={{ width: "100%", padding: "10px", borderRadius: "5px", border: "1px solid #ccc", fontSize: "16px", resize: "vertical" }}
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                style={{
                  backgroundColor: isSubmitting ? "#ccc" : colors.button,
                  color: "white",
                  border: "none",
                  padding: "12px",
                  borderRadius: "5px",
                  fontSize: "16px",
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                  fontWeight: "bold",
                  alignSelf: "flex-start"
                }}
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>
        </div>
          
          {/* --- SECTION 1: ACCOUNT DELETION --- */}
          <div style={{ padding: "25px", border: "1px solid #e9ecef", borderRadius: "8px", backgroundColor: "#fff0f0" }}>
            <h2 style={{ marginTop: 0, color: colors.danger }}>⚠ Account Deletion Request</h2>
            <p style={{ fontSize: "0.95rem", color: "#555" }}>
              If you wish to remove your account and all game data, please use the form below. 
            </p>
            <form onSubmit={onContactUsFormClicked} style={{ marginTop: "20px" }}>
              <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
                Enter your Game Username or Email:
              </label>
              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                <input
                  type="text"
                  value={deleteId}
                  onChange={(e) => setDeleteId(e.target.value)}
                  placeholder="e.g., CommanderJohn"
                  style={{ flex: 1, padding: "10px", border: "1px solid #ccc", borderRadius: "5px", fontSize: "16px" }}
                />
                <button
                  type="submit"
                  style={{ backgroundColor: colors.danger, color: "white", border: "none", padding: "10px 20px", borderRadius: "5px", fontSize: "16px", cursor: "pointer", fontWeight: "bold" }}
                >
                  Request Deletion
                </button>
              </div>
            </form>
          </div>

         

        {/* --- FOOTER --- */}
        <div style={{ marginTop: "50px", textAlign: "center", borderTop: "1px solid #eee", paddingTop: "20px", fontSize: "0.9rem", color: "#888" }}>
          <p>© 2026 Eventyol LLC. All rights reserved.</p>
        </div>
      </div>

      {/* --- SUCCESS POPUP MODAL --- */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: colors.overlay,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "10px",
              textAlign: "center",
              maxWidth: "400px",
              boxShadow: "0 5px 15px rgba(0,0,0,0.3)"
            }}
          >
            <div style={{ fontSize: "50px", marginBottom: "10px" }}>✅</div>
            <h3 style={{ color: colors.dark_blue, margin: "10px 0" }}>Message Received</h3>
            <p style={{ fontSize: "16px", color: "#555", lineHeight: "1.5" }}>
              We get your message , we will contact you soon about the your request.
            </p>
            <button
              onClick={() => setShowPopup(false)}
              style={{
                marginTop: "20px",
                backgroundColor: colors.success,
                color: "white",
                border: "none",
                padding: "10px 25px",
                borderRadius: "5px",
                fontSize: "16px",
                cursor: "pointer",
                fontWeight: "bold"
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default SinaniumMainPage;